
const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0
}

const callbacks: Map<Element, () => void> = new Map()

let observer: IntersectionObserver = undefined
function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && callbacks.has(entry.target)) {
          callbacks.get(entry.target)()
        }
      })
    }, options)
  }
  return observer
}

export function register(elem: Element, callback: () => void): void {
  callbacks.set(elem, callback)
  getObserver().observe(elem)
}

export function unregister(elem: Element): void {
  getObserver().unobserve(elem)
  callbacks.delete(elem)
  if (callbacks.size === 0) {
    observer.disconnect()
    observer = undefined
  }
}
